import { useEffect } from "react";
import { connect } from "react-redux";
import { Service } from "../../constants/actionType";
import { getCartItem } from "../../hooks/useCart";

function SplOfferDispatchOverlay(props) {
  const { buildProduct, cart, dispatch, productId } = props;

  useEffect(() => {
    // If the special offer NetMax 12 months on us is in the cart and buildProduct sploffer selectedProduct is not updated, then dispatch special offer
    try {
      if (productId) {
        const cartItem = getCartItem(cart, "PROMOTIONS", "SPECIALOFFERS", productId);
        const splOffer = buildProduct?.sploffer?.offerplansMTM?.find((o => o?.id === productId));
        if (splOffer && cartItem && buildProduct?.sploffer?.selectedProduct?.id !== productId) {
          if (splOffer?.offerFor?.toUpperCase() === Service.data) {
            dispatch({ type: "SPLOFFER_SELECTEDPRODID", value: splOffer });
            dispatch({ type: "SPLOFFER_SELECTEDPRODID_DATA", value: splOffer });
          } else if (splOffer?.offerFor?.toUpperCase() === Service.video) {
            dispatch({ type: "SPLOFFER_SELECTEDPRODID", value: splOffer });
            dispatch({ type: "SPLOFFER_SELECTEDPRODID_TV", value: splOffer });
          } else {
            dispatch({ type: "SPLOFFER_SELECTEDPRODID", value: splOffer });
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
  }, [cart, buildProduct?.sploffer]);

  return (
    <>
      {props?.children}
    </>
  );
}

const mapStateToProps = state => ({
  buildProduct: state?.buildProduct,
  cart: state?.cart,
})

export default connect(mapStateToProps)(SplOfferDispatchOverlay);
